export default {
    install: function () {
      // Empty
    },
  
    isDefined (value) {
      return (typeof value !== 'undefined' && value !== null && value !== 'null')
    },
  
    isBlank (value) {
      return !this.isDefined(value) || value.trim().length === 0
    },
  
    isNotBlank (value) {
      return this.isDefined(value) && value.trim().length > 0
    },
  
    getCleanValue (value) {
      if (typeof value === 'undefined' || value === null || value.trim() === 'null') {
        return ''
      }
  
      return value.trim()
    },
  
    getCleanIntValue (value) {
      if (typeof value === 'undefined' || value === null || value === 'null') {
        return ''
      }
  
      return parseInt(value, 10)
    },
  
    getBooleanValue (value) {
      if (typeof value === 'undefined' || value === null || value === 'null') {
        return false
      }
  
      return value
    },
  
    equals (o1, o2) {
      return o1 === o2
    },
  
    isEmpty (array) {
      if (this.isDefined(array)) {
        return this.equals(array.length, 0)
      }
      return true
    },
  
    toLowerCase (value) {
      if (this.isDefined(value)) {
        return this.getCleanValue(value.toLowerCase())
      }
      return ''
    },
  
    toUpperCase(value) {
      if (this.isDefined(value)) {
        return this.getCleanValue(value.toUpperCase())
      }
      return ''
    }
  }
  